var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExclamationGrey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.959,
    height: 17.959,
    viewBox: "0 0 17.959 17.959",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1131 -434)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1131 434)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#b5b5b5",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8.979,
    cy: 8.979,
    r: 8.979,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.979,
    cy: 8.979,
    r: 8.479,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(7.959 4.735)",
    fill: "#b5b5b5"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 6,
    transform: "translate(7.959 7.735)",
    fill: "#b5b5b5"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationGrey);
export default __webpack_public_path__ + "static/media/exclamation-grey.2df87cff6beb340b1320a1dcca51598c.svg";
export { ForwardRef as ReactComponent };